/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc
 */
import * as References from './ApprovalsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#createApproval
 */
export const CREATE_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_createApproval';
export const CREATE_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.CreateApprovalRequestType,
  References.CreateApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_APPROVAL_MUTATION_FIELD_NAME,
  args: [
    'approvalTypeId',
    'approvalAction',
    'approvableObjectId',
    'approvalSteps',
    'approvalRules',
    'approvalStages',
    'title',
    'requestNote',
    'dueDate',
  ],
  fetcher(
    request: References.CreateApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#createBulkApproval
 */
export const CREATE_BULK_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_createBulkApproval';
export const CREATE_BULK_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.CreateBulkApprovalRequestType,
  References.CreateBulkApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_BULK_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalRequests'],
  fetcher(
    request: References.CreateBulkApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateBulkApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createBulkApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#getLatestApproval
 */
export const GET_LATEST_APPROVAL_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_getLatestApproval';
export const GET_LATEST_APPROVAL_QUERY: RegisteredQuery<
  'result',
  References.GetLatestApprovalRequestType,
  References.GetLatestApprovalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LATEST_APPROVAL_QUERY_FIELD_NAME,
  args: ['approvalTypeId', 'approvalAction', 'approvableObjectId'],
  fetcher(
    request: References.GetLatestApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetLatestApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getLatestApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#getApproval
 */
export const GET_APPROVAL_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_getApproval';
export const GET_APPROVAL_QUERY: RegisteredQuery<
  'result',
  References.GetApprovalRequestType,
  References.GetApprovalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPROVAL_QUERY_FIELD_NAME,
  args: ['approvalId'],
  fetcher(
    request: References.GetApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getApprovalRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#approveApproval
 */
export const APPROVE_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_approveApproval';
export const APPROVE_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.ApproveApprovalRequestType,
  References.ApproveApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: APPROVE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'note'],
  fetcher(
    request: References.ApproveApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ApproveApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.approveApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#approveApprovalStep
 */
export const APPROVE_APPROVAL_STEP_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_approveApprovalStep';
export const APPROVE_APPROVAL_STEP_MUTATION: RegisteredQuery<
  'result',
  References.ApproveApprovalStepRequestType,
  References.ApproveApprovalStepResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: APPROVE_APPROVAL_STEP_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'note'],
  fetcher(
    request: References.ApproveApprovalStepRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ApproveApprovalStepResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.approveApprovalStepRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#rejectApproval
 */
export const REJECT_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_rejectApproval';
export const REJECT_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.RejectApprovalRequestType,
  References.RejectApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REJECT_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'rejectionNote'],
  fetcher(
    request: References.RejectApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RejectApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.rejectApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#rejectApprovalStep
 */
export const REJECT_APPROVAL_STEP_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_rejectApprovalStep';
export const REJECT_APPROVAL_STEP_MUTATION: RegisteredQuery<
  'result',
  References.RejectApprovalStepRequestType,
  References.RejectApprovalStepResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REJECT_APPROVAL_STEP_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'rejectionNote'],
  fetcher(
    request: References.RejectApprovalStepRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RejectApprovalStepResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.rejectApprovalStepRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestChangesOnApproval
 */
export const REQUEST_CHANGES_ON_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestChangesOnApproval';
export const REQUEST_CHANGES_ON_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.RequestChangesOnApprovalRequestType,
  References.RequestChangesOnApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REQUEST_CHANGES_ON_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'note'],
  fetcher(
    request: References.RequestChangesOnApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RequestChangesOnApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.requestChangesOnApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestChangesOnApprovalStep
 */
export const REQUEST_CHANGES_ON_APPROVAL_STEP_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestChangesOnApprovalStep';
export const REQUEST_CHANGES_ON_APPROVAL_STEP_MUTATION: RegisteredQuery<
  'result',
  References.RequestChangesOnApprovalStepRequestType,
  References.RequestChangesOnApprovalStepResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REQUEST_CHANGES_ON_APPROVAL_STEP_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'note'],
  fetcher(
    request: References.RequestChangesOnApprovalStepRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RequestChangesOnApprovalStepResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.requestChangesOnApprovalStepRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#markChangesResolved
 */
export const MARK_CHANGES_RESOLVED_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_markChangesResolved';
export const MARK_CHANGES_RESOLVED_MUTATION: RegisteredQuery<
  'result',
  References.MarkChangesResolvedRequestType,
  References.MarkChangesResolvedResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: MARK_CHANGES_RESOLVED_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(
    request: References.MarkChangesResolvedRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.MarkChangesResolvedResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.markChangesResolvedRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestAgentToApplyChanges
 */
export const REQUEST_AGENT_TO_APPLY_CHANGES_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestAgentToApplyChanges';
export const REQUEST_AGENT_TO_APPLY_CHANGES_MUTATION: RegisteredQuery<
  'result',
  References.RequestAgentToApplyChangesRequestType,
  References.RequestAgentToApplyChangesResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REQUEST_AGENT_TO_APPLY_CHANGES_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(
    request: References.RequestAgentToApplyChangesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RequestAgentToApplyChangesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.requestAgentToApplyChangesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#requestAgentToReview
 */
export const REQUEST_AGENT_TO_REVIEW_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_requestAgentToReview';
export const REQUEST_AGENT_TO_REVIEW_MUTATION: RegisteredQuery<
  'result',
  References.RequestAgentToReviewRequestType,
  References.RequestAgentToReviewResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REQUEST_AGENT_TO_REVIEW_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(
    request: References.RequestAgentToReviewRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RequestAgentToReviewResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.requestAgentToReviewRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#cancelAgentTurn
 */
export const CANCEL_AGENT_TURN_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_cancelAgentTurn';
export const CANCEL_AGENT_TURN_MUTATION: RegisteredQuery<
  'result',
  References.CancelAgentTurnRequestType,
  References.CancelAgentTurnResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CANCEL_AGENT_TURN_MUTATION_FIELD_NAME,
  args: ['approvalStepId', 'message'],
  fetcher(
    request: References.CancelAgentTurnRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CancelAgentTurnResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.cancelAgentTurnRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#cancelApproval
 */
export const CANCEL_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_cancelApproval';
export const CANCEL_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.CancelApprovalRequestType,
  References.CancelApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CANCEL_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'note'],
  fetcher(
    request: References.CancelApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CancelApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.cancelApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#concludeApproval
 */
export const CONCLUDE_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_concludeApproval';
export const CONCLUDE_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.ConcludeApprovalRequestType,
  References.ConcludeApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CONCLUDE_APPROVAL_MUTATION_FIELD_NAME,
  args: [
    'approvableObjectId',
    'approvalTypeId',
    'approvalAction',
    'approvalConclusionReason',
  ],
  fetcher(
    request: References.ConcludeApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ConcludeApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.concludeApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#updateApproval
 */
export const UPDATE_APPROVAL_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_updateApproval';
export const UPDATE_APPROVAL_MUTATION: RegisteredQuery<
  'result',
  References.UpdateApprovalRequestType,
  References.UpdateApprovalResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['approvalId', 'approvalSteps', 'dueDate', 'title', 'approvalStages'],
  fetcher(
    request: References.UpdateApprovalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateApprovalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateApprovalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsRpc#sendReminderNotification
 */
export const SEND_REMINDER_NOTIFICATION_MUTATION_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsRpc_sendReminderNotification';
export const SEND_REMINDER_NOTIFICATION_MUTATION: RegisteredQuery<
  'result',
  References.SendReminderNotificationRequestType,
  References.SendReminderNotificationResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SEND_REMINDER_NOTIFICATION_MUTATION_FIELD_NAME,
  args: ['approvalStepId'],
  fetcher(
    request: References.SendReminderNotificationRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SendReminderNotificationResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.sendReminderNotificationRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
